/*!
 * Stimpack Scroll
 *
 * @version : 1.0
 * @author  : Matthias Courville
 */

import { spIsBase64, spBase64Decode, spGetAnchorTarget } from '../utilities/utilities';

(function($){

    // ---------------------------------------------------------------------- //
    //
    // ---------------------------------------------------------------------- //

    var spOnScrollLastPosition = 0;

    var spOnScroll = function() {

        var scrollTop = $(window).scrollTop(),
            scrollDirection = scrollTop > spOnScrollLastPosition ? 'down' : 'up';

        $('body').attr('data-scroll-direction', scrollDirection);

        if (scrollTop > 1)
        {
			$('body').addClass('scrolled');
		}
		else
        {
			$('body').removeClass('scrolled');
		}

        spOnScrollLastPosition = scrollTop;
    };

    $(window).on('scroll', function() {
        spOnScroll();
    });

    // ---------------------------------------------------------------------- //
    // spScrollTo
    // ---------------------------------------------------------------------- //

    var spScrollBusy = false;
        //spScrollToDoneTimeout = 0;

    var spGetScrollOffset = function()
    {
        var offset = 0;

        if (STIMPACK.scrollOffset)
        {
            if (typeof STIMPACK.scrollOffset === 'object')
            {
                jQuery.each(STIMPACK.scrollOffset, function(index, selector) {

                    jQuery(selector).each(function() {
                        offset -= $(this).outerHeight();
                    });
                });
            }
            else
            {
                offset += parseInt(STIMPACK.scrollOffset);
            }
        }

        return offset;
    };

    var spScrollTo = function(options)
    {
        if (true === spScrollBusy && !options.force)
        {
            return;
        }

        spScrollBusy = true;

        var defaultOptions = {
            target          : null,
            targetOffset    : 'top',
            speed           : 600,
            offset          : 0,
            offsetCallback  : spGetScrollOffset,
            onDone          : false
        };

        if (typeof options !== 'object' || options instanceof jQuery)
        {
            defaultOptions.target = options;
            options = defaultOptions;
        }
        else
        {
            options = jQuery.extend({}, defaultOptions, options);
        }

        // Target --------------------------------------------------------------- //
        if (!jQuery.isNumeric(options.target))
        {
            if (typeof options.target === 'string')
            {
                options.target = jQuery(options.target);
            }

            if (options.target.length > 0)
            {
                options.target = options.target.offset().top + (('bottom' === options.targetOffset) ? options.target.outerHeight() : 0);
            }
            else
            {
                options.target = 0;
            }
        }

        // Offset --------------------------------------------------------------- //
        options.target = parseInt(options.target) + parseInt(options.offset);

        if (options.offsetCallback && typeof options.offsetCallback === 'function')
        {
            options.target += options.offsetCallback.call();
        }

        // Scroll --------------------------------------------------------------- //
        jQuery('html, body').stop().animate({scrollTop: options.target}, options.speed, function() {

            if (options.onDone && typeof options.onDone === 'function')
            {
                //clearTimeout(spScrollToDoneTimeout);
                //spScrollToDoneTimeout =

                setTimeout(function() {options.onDone.call();}, 10);
            }

            spScrollBusy = false;
        });
    };

    // ---------------------------------------------------------------------- //
    // spScrollToLink
    // ---------------------------------------------------------------------- //

    var spAnchor = function(options)
    {
        var _this = this;

        this.defaultOptions = {
            root        : false,
            target      : '',
            selector    : '',
            breakpoint  : false
        };

        this.options = $.extend({}, this.defaultOptions, options);

        /*this.el = {
            container: typeof this.options.container === 'object' ? this.options.container : $(this.options.container)
        };

        if (this.options.updateOnResize)
        {
            $(window).on('resize', function() {
                _this.updateHeight();
            });
        }

        this.updateHeight();*/

        return this;
    };

    spAnchor.prototype.init = function(offset)
    {
        if (0 === 0)
        {
            this.el.root.on('click', this.options.selector, function(e) {

            });
        }
        else
        {
            this.el.root.on('click', function(e) {

            });
        }
    };

    spAnchor.prototype.scrollTo = function(el)
    {
        var options = el.data('_sp-scroll-to');

        if (typeof options === 'undefined')
        {
            options = el.data('sp-scroll-to');

            if (typeof options == 'string')
            {
                options = {target: options};
            }
            else if (spIsBase64(options))
            {
                options = JSON.parse(spBase64Decode(options));
            }

            //options = (typeof _options == 'object') ? $.extend({}, this.options, options) : this.options;

            //options.target = spGetAnchorTarget(options.target);

            el.data('_sp-scroll-to', options);
        }

        spScrollTo(options);
    };


    $.spAnchor = $.fn.spAnchor = function(options)
    {
        options = options || {};

        if (typeof this === 'function')
        {
            this.spAnchor = new spAnchor(options);
        }

        console.log(this);
    };

    /*$('test-anchor').spAnchor();

    $.spAnchor({
        'root'      : 'body',
        'selector'  : '.sp-scroll, [data-sp-scroll]'
    });

    $.spAnchor({
        'root'      : '.sp-scroll-auto',
        'selector'  : 'a'
    });*/



    /*
    spAnchor.prototype.init = function(offset)
    {
        this.el.root.on('click', this.options.selector, function(e) {

        });
    };

    spAnchor.prototype.getTarget = function()
    {
        return spGetAnchorTarget();
    };

    spAnchor.prototype.scrollTo = function()
    {
        var el = '',
            options = el.data('sp-anchor-options');

        if (typeof options === 'undefined')
        {
            options = $(this).data('sp-anchor');

            if (options)
            {
                if (typeof options == 'string')
                {
                    options = $.extend({}, this.options, {target: options});
                }
                else if (typeof _options == 'object')
                {
                    options = $.extend({}, this.options, options);
                }
                else if (spIsBase64(options))
                {
                    options = $.extend({}, this.options, JSON.parse(spBase64Decode(options)));
                }
            }

            options.target = spGetAnchorTarget(options.target);

            el.data('sp-anchor-options', options);
        }

        spScrollTo(options);
    };
    */

    /*$('body').on('click', '.sp-anchor, [data-sp-anchor]', function(e) {

        e.preventDefault();

        var options = $(this).data('sp-scroll') || {};

        if (typeof options !== 'object')
        {
            if (typeof options == 'string')
            {
                options = {target: options};
            }
            else if (spIsBase64(options))
            {
                options = JSON.parse(spBase64Decode(_options));
            }
        }

        if (!options.target)
        {
            options.target = $(this).attr('href');
        }

        spScrollTo(options);
    });


    $('.sp-anchor-auto').on('click', 'a', function(e) {

        var el = $(this),
            target = el.attr('href');

        if (target && '#' === target.charAt(0))
        {
            e.preventDefault();
            spScrollTo(options);
        }
    });*/


})(jQuery);
